import React from 'react';
import type { ImageBlockContent } from '../../../types/popup.types';

interface ImageBlockProps {
  content: ImageBlockContent;
}

const ImageBlock: React.FC<ImageBlockProps> = ({ content }) => {
  const { 
    url, 
    alt, 
    width, 
    link, 
    borderRadius, 
    showText, 
    textPosition, 
    title, 
    text, 
    textAlign 
  } = content;

  // URL boş ise render etme
  if (!url || url.trim() === '') {
    return null;
  }

  const imageElement = (
    <img
      src={url}
      alt={alt || ''}
      className="img-fluid"
      style={{
        width: width || '100%',
        borderRadius: `${borderRadius || 0}px`,
        maxWidth: '100%',
      }}
      loading="lazy"
    />
  );

  const imageContent = link ? (
    <a href={link} target="_blank" rel="noopener noreferrer">
      {imageElement}
    </a>
  ) : (
    imageElement
  );

  if (showText && (title || text)) {
    const textContent = (
      <div style={{ textAlign: textAlign || 'center' }}>
        {title && (
          <h4 style={{ margin: '0 0 8px', fontSize: '16px', fontWeight: 600 }}>
            {title}
          </h4>
        )}
        {text && (
          <p style={{ margin: 0, fontSize: '14px', color: '#666' }}>
            {text}
          </p>
        )}
      </div>
    );

    switch (textPosition) {
      case 'top':
        return (
          <div style={{ marginBottom: '16px' }}>
            <div style={{ marginBottom: '12px' }}>{textContent}</div>
            {imageContent}
          </div>
        );
      case 'bottom':
        return (
          <div style={{ marginBottom: '16px' }}>
            {imageContent}
            <div style={{ marginTop: '12px' }}>{textContent}</div>
          </div>
        );
      case 'left':
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '16px' }}>
            <div style={{ flex: 1 }}>{textContent}</div>
            <div style={{ flex: 1 }}>{imageContent}</div>
          </div>
        );
      case 'right':
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '16px' }}>
            <div style={{ flex: 1 }}>{imageContent}</div>
            <div style={{ flex: 1 }}>{textContent}</div>
          </div>
        );
      default:
        return <div style={{ marginBottom: '16px' }}>{imageContent}</div>;
    }
  }

  return <div style={{ marginBottom: '16px' }}>{imageContent}</div>;
};

export default ImageBlock;
